<template>
  <div>
    <div v-if="lang == 0" id="footer" class="container-fluid">
      <p class="address_tel_fax">
        <span>庆铨彩艺包装印刷(东莞)有限公司 版权所有,并保留所有权利。</span>
      </p>
      <p class="address_tel_fax">
        <span
          >电话:86-769-2229316722293667 传真:86-769-22205170
          E-mail:chch@chingchuan.cn</span
        >
      </p>
      <p class="email_wx">
        <span>地址:广东省东莞市东城光明工业区6号</span>
      </p>
      <a class="email_wx" rel="nofollow" href="https://beian.miit.gov.cn" target="_blank"
        >粤ICP备13039792号-2</a
      >
      <!-- <p class="email_wx">粤ICP备13039792号-2</p> -->
    </div>
    <div v-if="lang == 1" id="footer" class="container-fluid">
      <p class="address_tel_fax">
        <span
          >ALL RIGHTS RESERVED BY CHING CHUAN PACKING & PRINTING ( DONGGUAN ) CO.
          LTD</span
        >
      </p>
      <p class="address_tel_fax">
        <span
          >TEL:86-769-22293167 22293667 FAX:86-769-22205170
          E-mail:chch@chingchuan.cn</span
        >
      </p>
      <p class="email_wx">
        <span
          >ADD: NO.6.GUANGMING COUNTY DONG CHENG DISTRICT DONGGUAN CITY GUANG DONG
          PROVINCE.CHINA</span
        >
      </p>
      <a class="email_wx" rel="nofollow" href="https://beian.miit.gov.cn" target="_blank"
        >粤ICP备13039792号-2</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      lang: "",
    };
  },
  mounted() {
    const lang = localStorage.getItem("lang");
    this.lang = lang;
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  margin-top: 30px;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue